<template>
    <div class="ring"></div>
</template>

<script>
export default {
    name: "",
    props: ["data"],
    data() {
        return {
            ringData: []
        };
    },
    methods: {
        setChart() {
            let data = [
                [
                    {
                        name: "核心风险已预警",
                        value: this.data["核心风险已预警"] === this.data["核心风险未预警"] ? null : this.data["核心风险已预警"]
                    },
                    {
                        name: "核心风险未预警",
                        value: this.data["核心风险未预警"]
                    }
                ],
                [
                    {
                        name: "运营风险已预警",
                        value: this.data["运营风险已预警"] === this.data["运营风险未预警"] ? null : this.data["运营风险已预警"]
                    },
                    {
                        name: "运营风险未预警",
                        value: this.data["运营风险未预警"]
                    }
                ],
                [
                    {
                        name: "发展风险已预警",
                        value: this.data["发展风险已预警"] === this.data["发展风险未预警"] ? null : this.data["发展风险已预警"]
                    },
                    {
                        name: "发展风险未预警",
                        value: this.data["发展风险未预警"]
                    }
                ]
            ];
            const obj = {
                type: "pie",
                avoidLabelOverlap: false,
                tooltip: {
                    confine: true,
                    trigger: "item"
                },
                color: ["rgba(225, 106, 106, 1)", "rgba(89, 207, 122, 1)"],
                label: {
                    show: false,
                    position: "center"
                },
                labelLine: {
                    normal: {
                        show: false
                    }
                }
            };

            const option = {
                tooltip: {
                    trigger: "item"
                },
                series: [
                    {
                        ...obj,
                        radius: ["80%", "90%"],
                        data: data[2]
                    },
                    {
                        ...obj,
                        radius: ["60%", "70%"],
                        data: data[1]
                    },
                    {
                        ...obj,
                        radius: ["40%", "50%"],
                        data: data[0]
                    }
                ]
            };
            let myChart = this.$echarts(this.$el);
            myChart.clear();
            myChart.resize();
            myChart.setOption({
                ...option,
                animation: false
            });
        }
    },
    mounted() {
        this.setChart();
    }
};
</script>

<style lang="less" scoped>
.ring {
    width: 100%;
    height: 100%;
}
</style>
